import api from '../api'

export const persist = async (tires, homepageDomain, locationId, isBillTo) => {

	let hasBillToPrefs = false
	let hasUpdateCreate = false

	for (let a of tires) {
		if (a.isBillToPreference) {
			hasBillToPrefs = true
		}
		if (a.isCreate || a.isDelete || a.isUpdate) {
			hasUpdateCreate = true
		}
	}	

	let axleTirePref

	//if hasBillToPrefs and hasUpdateCreate and !isBillTo, create and update
	if (hasBillToPrefs && hasUpdateCreate && !isBillTo) {
		//create a tire pref id
		const axleTireResponse = await api.service('axleTirePreferences').create({
			name: homepageDomain.profileName, 
			fleetId: homepageDomain.homePageDomain.fleetId 
		})
		axleTirePref = axleTireResponse.id
		await api.service('fleetLocations').patch(locationId, {
			axleTirePreferenceId: axleTireResponse.id
		})

		//loop through the wheels, save them
		for (const tire of tires) {
			await api.service('axleTireDetails').create({
				preferencesId: axleTirePref,
				priority: tire.priority,
				isRetread: tire.tireType,
				brandId: tire.tireBrand,
				treadId: tire.tread,
				loadRangeId: tire.loadRange,
				tireApplicationId: tire.application,
				comments: tire.comments,
				sizeId: tire.tireSize,
				axleTypeId: tire.axleType,
				isErs: true
			})

		}

	}else {
		for (const tire of tires) {
			if (tire.isCreate) {
				if (!axleTirePref) {
					let resp = await api.service('fleetLocations').find({
						query: {
							id: {
								$eq: locationId
							}
						}
					})
					axleTirePref = resp.data[0].axleTirePreferenceId
	
					if (!axleTirePref) {
						const axleTireResponse = await api.service('axleTirePreferences').create({
							name: homepageDomain.profileName,
							fleetId: homepageDomain.homePageDomain.fleetId  
						})
						axleTirePref = axleTireResponse.id
						await api.service('fleetLocations').patch(locationId, {
							axleTirePreferenceId: axleTireResponse.id
						})
					}
				}
				await api.service('axleTireDetails').create({
					preferencesId: axleTirePref,
					priority: tire.priority,
					isRetread: tire.tireType,
					brandId: tire.tireBrand,
					treadId: tire.tread,
					loadRangeId: tire.loadRange,
					tireApplicationId: tire.application,
					comments: tire.comments,
					sizeId: tire.tireSize,
					axleTypeId: tire.axleType,
					isErs: true
				})
			} else if (tire.isDelete) {
				await api.service('axleTireDetails').remove(null, {
					query: {
						id: {
							$eq: tire.id
						}
					}
				})
			} else if (tire.isUpdate) {
				await api.service('axleTireDetails').patch(tire.id, {
					priority: tire.priority,
					isRetread: tire.tireType,
					brandId: tire.tireBrand,
					treadId: tire.tread,
					loadRangeId: tire.loadRange,
					tireApplicationId: tire.application,
					comments: tire.comments,
					sizeId: tire.tireSize,
					axleTypeId: tire.axleType
				})
			}
		}

	}



	




}


// WEBPACK FOOTER //
// ./src/database/tirePreferences.js